var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card__item strong_team flex flex-col justify-center"},[_c('img',{staticClass:"h-12",attrs:{"src":_vm.img,"alt":_vm.imgAlt}}),_c('div',{staticClass:"section__title mt-4 mb-0 md:text-lg"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }